import { Empty, Tabs } from 'antd'
import { FC } from 'react'
import styled from 'styled-components'
import Machine from '../../../../../types/api/machine'
import MachineQueue from './components/machine-queue/machine-queue'
import MachineWaitingQueue from './components/machine-waiting-queue/machine-waiting-queue'

const TabsStyled = styled(Tabs)`
    height: 100%;
    overflow: hidden;

    & .ant-tabs-content {
        height: 100%;
    }

    & .ant-tabs-tabpane {
        height: 100%;
        display: flex;
    }
`

const QueueLayout = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
`

const MainQueue = styled.div`
    height: 70%;
    position: relative;
`

const WaitingQueue = styled.div`
    height: 30%;
`

const EmptyState = styled.div`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

interface MachinesQueuesProps {
    machines: Machine[]
    isLoading: boolean
}

const MachinesQueues: FC<MachinesQueuesProps> = ({ machines, isLoading }) => {
    if (!isLoading && machines.length === 0) {
        return (
            <EmptyState>
                <Empty description='Станки перемотки не найдены' />
            </EmptyState>
        )
    }

    return (
        <TabsStyled
            destroyInactiveTabPane
            items={[...machines]
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(machine => ({
                    label: machine.name,
                    key: machine.documentId,
                    children: (
                        <QueueLayout>
                            <MainQueue>
                                <MachineQueue machineDocId={machine.documentId} />
                            </MainQueue>
                            <WaitingQueue>
                                <MachineWaitingQueue machineDocId={machine.documentId} />
                            </WaitingQueue>
                        </QueueLayout>
                    ),
                }))}
        />
    )
}

export default MachinesQueues
